import React, { useEffect, useState } from 'react';
import axios from 'axios';

const OrderListAssigned = () => {
  const [orders, setOrders] = useState([]);
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    const username = localStorage.getItem('username');
    if (username) {
      setCurrentUser(username);
    }
  }, []);

  useEffect(() => {
    const fetchAssignedOrders = async () => {
      try {
        const res = await axios.get(`https://astrovidhya.in/api/orders/assigned/${currentUser}`);
        setOrders(res.data);
      } catch (err) {
        console.error("Error fetching assigned orders:", err);
      }
    };

    if (currentUser) {
      fetchAssignedOrders();
    }
  }, [currentUser]);

  const handleSubmit = async (order) => {
    try {
      const shouldGoToVerify =
        (order.payment_method === 'cod' && order.discount > 0) ||
        (order.payment_method === 'prepaid');

      const endpoint = shouldGoToVerify
        ? 'https://astrovidhya.in/api/order-verify'
        : 'https://astrovidhya.in/api/to-pack';

      await axios.post(endpoint, order);

      // Optional: update original order's status
      await axios.put(`https://astrovidhya.in/api/orders/${order._id}`, {
        status: shouldGoToVerify ? 'order_verify' : 'to_pack'
      });

      // Remove order from the table
      setOrders(prev => prev.filter(o => o._id !== order._id));
    } catch (err) {
      console.error("Error submitting order:", err);
      alert("Failed to process order.");
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">📦 Assigned Orders From Admin</h2>

      {orders.length === 0 ? (
        <p>No orders assigned to you yet.</p>
      ) : (
        <table className="w-full table-auto border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border p-2">#</th>
              <th className="border p-2">Order No</th>
              <th className="border p-2">Customer</th>
              <th className="border p-2">Payment</th>
              <th className="border p-2">Discount</th>
              <th className="border p-2">Submit</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={order._id} className="hover:bg-gray-50">
                <td className="border p-2">{index + 1}</td>
                <td className="border p-2">{order.order_no || "N/A"}</td>
                <td className="border p-2">{order.customer_name || "N/A"}</td>
                <td className="border p-2">{order.payment_method}</td>
                <td className="border p-2">{order.discount || 0}</td>
                <td className="border p-2">
                  <button
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    onClick={() => handleSubmit(order)}
                  >
                    Submit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrderListAssigned;
